import { VISUALLY_HIDDEN } from '@lumx/core/js/constants';

/**
 * Visually hidden class name.
 * Used to hide elements from view but keep them readable from screen readers
 */
export const visuallyHidden = () => VISUALLY_HIDDEN;
